import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
} from "../../../../components";
import { value } from "../../../../helpers";
import { formatDate, formatPrice } from "../../../../utils";
import { format } from "date-fns";
import { obterIconeStatus } from "../../../../entities/pdv";
import { useState } from "react";

export default function HistoricoNfSaidaDialog({
  open,
  handleCloseDialog,
  operacaoFiscalList,
  listaNfSaida,
  nfSaidaRowCount,
  buscarNfSaida,
  clienteList,
  pdvOnLine,
}) {
  const apiRef = useGridApiRef();
  const [page, setPage] = useState(0);
  const filtros = {
    orderBy: "updatedAt",
    order: "desc",
    page: "1",
  };
  const colunas = [
    {
      field: "status",
      headerName: "Status",
      headerClassName: "table-pdv-header",
      sortable: false,
      flex: 100,
      renderCell: (params) => obterIconeStatus(params.value),
    },
    {
      field: "serieDocumento",
      headerName: "Série",
      sortable: false,
      headerClassName: "table-pdv-header",
      width: 100,
      valueGetter: (params) => value.text(params.value),
    },
    {
      field: "numeroDocumento",
      headerName: "Nº Documento",
      headerClassName: "table-pdv-header",
      flex: 170,

      sortable: false,
    },
    {
      field: "operacaoFiscalId",
      headerName: "Operação Fiscal",
      headerClassName: "table-pdv-header",
      flex: 250,

      sortable: false,
      valueGetter: (params) =>
        operacaoFiscalList.find((item) => item.id == params.value)?.descricao,
    },
    {
      field: "createdAt",
      headerName: "Data de Lançamento",
      headerClassName: "table-pdv-header",
      width: 200,
      sortable: false,
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
    },
    {
      field: "clienteNome",
      headerName: "Cliente",
      headerClassName: "table-pdv-header",
      width: 300,
      sortable: false,
      valueGetter: (params) =>
        params.value ??
        clienteList.find((item) => item.id == params.row.clienteId)
          ?.nomeRazaoSocial,
    },
    {
      field: "nfSaidaItens",
      headerName: "Total da Venda",
      headerClassName: "table-pdv-header",
      flex: 250,
      sortable: false,
      valueGetter: (params) => {
        const totalItensDespesasNfSaida =
          params.value
            .map((item) => item.subtotal)
            .reduce((acumulador, total) => acumulador + total, 0) -
          params.row.desconto +
          params.row.despesas +
          (params.row.subtotalTributosIncidentes || 0);
        const totalNfSaida = params.row.freteCompoeNota
          ? totalItensDespesasNfSaida + params.row.frete
          : totalItensDespesasNfSaida;
        return formatPrice(totalNfSaida);
      },
    },
  ];

  const handlePageChange = (params) => {
    setPage(params.page);
    if (pdvOnLine) {
      filtros.page = (params.page + 1).toString();
      buscarNfSaida({ ...filtros });
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xl"
      PaperComponent="div"
      open={open}
      aria-labelledby="form-dialog-title"
      onClose={handleCloseDialog}
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title="Histórico NF Saída" />
          <CardContent className="p-3">
            <DataGrid
              sx={{
                height: "65vh",
                fontFamily: "'Montserrat', sans-serif !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: 600,
                  fontSize: "1rem",
                },
                "& .MuiDataGrid-cell": {
                  paddingBlock: 1.5,
                },
              }}
              apiRef={apiRef}
              columns={colunas}
              rows={listaNfSaida}
              paginationMode={pdvOnLine ? "server" : "client"}
              getRowHeight={() => "auto"}
              page={page}
              pageSizeOptions={[]}
              disableColumnMenu
              onPaginationModelChange={(params) => handlePageChange(params)}
              rowCount={nfSaidaRowCount}
              disableColumnFilter
              disableDensitySelector
              hideFooterSelectedRowCount
              disableRowSelectionOnClick
              slots={{
                noRowsOverlay: () => (
                  <div className="d-flex flex-column align-items-center justify-content-center h-100">
                    <span className="text-gray-500">
                      Nenhuma NF de saída encontrada.
                    </span>
                  </div>
                ),
              }}
            />
          </CardContent>
          <CardActions className="d-flex justify-content-end">
            <Button
              color="inherit"
              variant="contained"
              disableElevation
              onClick={handleCloseDialog}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              />
              Fechar
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
}
